import { render, staticRenderFns } from "./mechanismBind.vue?vue&type=template&id=e572199a&scoped=true&"
import script from "./mechanismBind.vue?vue&type=script&lang=js&"
export * from "./mechanismBind.vue?vue&type=script&lang=js&"
import style0 from "./mechanismBind.vue?vue&type=style&index=0&id=e572199a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e572199a",
  null
  
)

export default component.exports